export function getLocationGroupLabel(locationCode, locationName) {
  const code = String(locationCode || '').trim();
  const name = String(locationName || '').trim();

  if (code && name && name !== code) {
    return `${code} - ${name}`;
  }

  return code || name || 'Unassigned Location';
}

export function groupRowsByLocation(rows = [], {
  getCode = (row) => row?.locationCode,
  getName = (row) => row?.locationName
} = {}) {
  const groupMap = new Map();

  rows.forEach((row) => {
    const code = String(getCode(row) || '').trim();
    const name = String(getName(row) || '').trim();
    const key = code || name || 'unassigned';

    if (!groupMap.has(key)) {
      groupMap.set(key, {
        key,
        locationCode: code,
        locationName: name,
        label: getLocationGroupLabel(code, name),
        rows: []
      });
    }

    groupMap.get(key).rows.push(row);
  });

  return Array.from(groupMap.values());
}

export function hasMultipleLocationGroups(groups = []) {
  return groups.length > 1;
}
